import { Observable } from 'rxjs';

export const fileUrlFromBlob = (blob: Blob) =>
  new Observable<string>(observer => {
    const reader = new FileReader();
    reader.addEventListener('load', event => {
      observer.next(event.target.result as string);
      observer.complete();
    });
    reader.addEventListener('error', error => {
      observer.error(error);
      observer.complete();
    });
    reader.readAsDataURL(blob);
  });
